/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CompleteInMeetingType } from './completeInMeetingType';
import type { EntityHint } from './entityHint';
import type { PartIn } from './partIn';

export interface CompleteIn {
  upload_token: string;
  /** @minItems 1 */
  parts: PartIn[];
  /** @pattern ^[0-9a-f]{64}$ */
  content_hash: string;
  /** @minimum 0 */
  duration_s: number;
  started_at: string;
  entity_hint?: EntityHint | null;
  project_id?: string | null;
  title?: string | null;
  meeting_type?: CompleteInMeetingType;
}
